import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button'

export default class NotAuthorized extends React.Component {
    render() {
        const user = this.props.user;
        const userLabel = user && (user.email || user.displayName);
        const switchAccount = async () => {
            await this.props.signOut();
            if (this.props.signIn) this.props.signIn();
        };
        return (
            <Container className="SignIn">
                <Row style={{minHeight: '35vh'}} />
                <Row>
                    <Col className="SignInText">
                        {this.props.authError
                            ? "We couldn't verify your access for this team."
                            : "You are not authorized to view this content."}
                    </Col>
                </Row>
                {userLabel && (
                    <>
                        <Row style={{minHeight: '1vh'}} />
                        <Row>
                            <Col style={{textAlign: 'center'}}>
                                Signed in as <strong>{userLabel}</strong>
                            </Col>
                        </Row>
                    </>
                )}
                {this.props.authError && (
                    <>
                        <Row style={{minHeight: '1vh'}} />
                        <Row>
                            <Col style={{textAlign: 'center', color: '#a00'}}>
                                {this.props.authError}
                            </Col>
                        </Row>
                    </>
                )}
                <Row style={{minHeight: '2vh'}} />
                <Row>
                    <Col style={{textAlign: 'center'}}>
                        <Button className="SignInButton" onClick={switchAccount} style={{marginRight: '0.5rem'}}>
                            Switch account
                        </Button>
                        <Button className="SignInButton" variant="secondary" onClick={() => this.props.signOut()}>
                            Sign out
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    }
}
